// extracted by mini-css-extract-plugin
export default {"heading":"AddCreative_heading__oLYtk","wrapper":"AddCreative_wrapper__yg8Z1"};